import {
	TICKET_STATUSES,
	type TicketKind,
	type TicketStatus,
} from "@zplanem/responses"

export const TICKET_BOARD_STATUSES = TICKET_STATUSES

export interface PropertyTicketListFilters {
	status?: TicketStatus
	cursor?: string | null
	limit?: number
	projectId?: string
	assigneeId?: string
	topicId?: string
	kind?: TicketKind
}

export interface MyTicketListFilters {
	status?: TicketStatus
	cursor?: string | null
	limit?: number
	propertyId?: string
	projectId?: string
	kind?: TicketKind
}

export function ticketListApiPath(
	propertyId: string,
	filters: PropertyTicketListFilters,
): string {
	const qs = ticketListQueryString(filters)
	return `/api/common/properties/${propertyId}/tickets${qs}`
}

export function myTicketsApiPath(filters: MyTicketListFilters): string {
	const qs = ticketListQueryString(filters)
	return `/api/common/users/me/tickets${qs}`
}

function ticketListQueryString(
	filters: PropertyTicketListFilters | MyTicketListFilters,
): string {
	const params = new URLSearchParams()
	if (filters.status) params.set("status", filters.status)
	if (filters.cursor) params.set("cursor", filters.cursor)
	if (filters.limit) params.set("limit", String(filters.limit))
	if ("propertyId" in filters && filters.propertyId)
		params.set("propertyId", filters.propertyId)
	if ("projectId" in filters && filters.projectId)
		params.set("projectId", filters.projectId)
	if ("assigneeId" in filters && filters.assigneeId)
		params.set("assigneeId", filters.assigneeId)
	if ("topicId" in filters && filters.topicId)
		params.set("topicId", filters.topicId)
	if ("kind" in filters && filters.kind) params.set("kind", filters.kind)
	return params.size > 0 ? `?${params.toString()}` : ""
}

export function ticketDetailApiPath(
	propertyId: string,
	ticketId: string,
): string {
	return `/api/common/properties/${propertyId}/tickets/${ticketId}`
}

export function ticketStatusApiPath(
	propertyId: string,
	ticketId: string,
): string {
	return `${ticketDetailApiPath(propertyId, ticketId)}/status`
}

export function ticketCommentsApiPath(
	propertyId: string,
	ticketId: string,
): string {
	return `${ticketDetailApiPath(propertyId, ticketId)}/comments`
}

export function ticketCommentApiPath(
	propertyId: string,
	ticketId: string,
	commentId: string,
): string {
	return `${ticketCommentsApiPath(propertyId, ticketId)}/${commentId}`
}

export function ticketAttachmentCreateApiPath(
	propertyId: string,
	ticketId: string,
	target: { commentId?: string } = {},
): string {
	return target.commentId
		? `${ticketCommentApiPath(propertyId, ticketId, target.commentId)}/attachments`
		: `${ticketDetailApiPath(propertyId, ticketId)}/attachments`
}

export function ticketAttachmentConfirmApiPath(
	propertyId: string,
	ticketId: string,
	fileId: string,
): string {
	return `${ticketDetailApiPath(propertyId, ticketId)}/attachments/${fileId}/confirm`
}

export function ticketAttachmentDeleteApiPath(
	propertyId: string,
	ticketId: string,
	fileId: string,
): string {
	return `${ticketDetailApiPath(propertyId, ticketId)}/attachments/${fileId}`
}

export function ticketBoardCacheRoot(propertyId: string) {
	return ["properties", propertyId, "tickets"] as const
}
